import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import VoucherAd from '../components/voucher-ad'
import config from '../../data/siteConfig'

const StagPage = () => (
  <span>
    <Helmet
      title={`${config.siteName} | Stag & Hen Parties | ${config.siteTitleAlt}`}
      meta={[
        {
          name: 'description',
          content: 'Book your 4x4 experience day for Stag & Hen Parties or even ‘Stens’. Based in Cardiff South Wales with specially designed 4x4 off roading courses'
        }
      ]}
    />
    <div className="stag-hen banner">
      <div className="banner-info top-off-center text-center">
        <h2 className="uppercase">Your one stop shop for <br/>Stag & Hen parties</h2>
        <a className="button secondary uppercase large hide-for-small-only" href="/bookings">Bookings</a>
      </div>
    </div>
    <main>
      <section className="row">
        <div className="small-12 medium-10 columns">
          <div className="content-header">
            <h1 className="uppercase">Stag & Hen party packages</h1>
          </div>
        </div>
      </section>
      <section className="row">
        <div className="large-9 columns">
          <div className="content-body">
            <h3 className="subheader">We specialise In giving your group a day to remember.</h3>
            <p><strong>If you are looking for a one stop shop for your party we can cater for all your needs.</strong></p>
            <p>Whether your looking for a whole day experience where you get to sample a variety of fun packed activities ...or your looking for that more trailer made approach we can accommodate your group.</p>
            <p><i>We have a “stag goes free” policy on groups of 10 or more.</i></p>
            <p>Our team can provide:</p>
            <ul>
              <li>4x4 experience days</li>
              <li>Clay pigeon shooting</li>
              <li>Mini bus hire</li>
              <li>Help sourcing hotels</li>
            </ul>
            <p>All available from our 40 acre site which is easily within reach of the centre of Cardiff for your evening out.</p>
            <p>If you need advice on where to go in Cardiff or where to stay we’re happy to advise best we can.</p>
          </div>
        </div>
        <aside className="large-3 columns">
          <div className="content-body">
            <VoucherAd />
          </div>
        </aside>
      </section>
    </main>
  </span>
)

export default StagPage



// WEBPACK FOOTER //
// ./src/pages/stag-and-hen-parties.js